import { Injectable } from '@angular/core';
import { GeneralService } from '@shared/services/general.service';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  constructor(private generalService: GeneralService) {}

  get(name: string) {
    if (this.generalService.isBrowserOnly) {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(`${name}=`)) {
          return cookie.substring(name.length + 1);
        }
      }
    }
    return null;
  }

  set(name: string, value: string, daysUntilExpire: number) {
    if (this.generalService.isBrowserOnly) {
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + daysUntilExpire);
      const cookieValue =
        encodeURIComponent(value) +
        (daysUntilExpire ? `; expires=${expirationDate.toUTCString()}` : '');
      document.cookie = `${name}=${cookieValue}; path=/`;
    }
  }

  delete(name: string) {
    if (this.generalService.isBrowserOnly) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  }
}
